import React, { useCallback, useEffect, useState } from 'react'
import DashboardLayout from '../../../layoutcontainers/DashboardLayout'
import UnderDevelopmentPage from '../../UnderDevelopmentPage'
import { AppBar, Box, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Toolbar } from '@mui/material'
import MaterialTypography from '../../../components/MaterialTypography'
import MaterialButton from '../../../components/MaterialButton'
import ActivePlans from './components/ActivePlans'
import ClosedPlans from './components/ClosedPlans'
import AddTestPlan from './components/AddTestPlan'
import { fetchData } from '../../Utils/Baseurl'
import MaterialSelect from '../../../components/MaterialSelect'
import { useLoading } from '../../../context/loadingcontext'
import { getProjectsMiddleware } from '../../../api/projectMiddleware'



const TestPlans = () => {

  const [activeTab, setActiveTab] = useState("active");
  const [search, setSearch] = useState('');
  const [filter, setFilter] = useState('');
  const [open, setOpen] = useState(false);
  const [projectList, setProjectList] = useState([]);
  const [selectedProject, setSelectedProject] = useState('');
  const [editData, setEditData] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const testPlanRef = React.useRef();
  const { setCirleLoading } = useLoading();



  const fetchProjects = useCallback(async () => {
    setCirleLoading(true);
    try {
      const userId = sessionStorage.getItem("currentUser");
      if (userId) {
        const response = await getProjectsMiddleware(userId);

        if (response && response.data) {
          const formattedProjects = response.data.map(proj => ({
            value: proj.project_id,
            label: proj.project_name
          }));
          setProjectList(formattedProjects);
          if (formattedProjects.length > 0) {
            setSelectedProject(formattedProjects[0]);
          }
        }
      }
    } catch (error) {
      console.error("Error fetching projects:", error);
    } finally {
      setCirleLoading(false);
    }
  }, [setCirleLoading]);

  useEffect(() => {
    fetchProjects();
  }, [fetchProjects]);

  const handleClose = () => {
    setOpen(false);
    setEditData(null);
    setIsEditMode(false);
  };

  const handleTestPlanOpen = () => {
    setIsEditMode(false);
    setEditData(null);
    setOpen(true);
  };

  const handleEdit = (data) => {
    setEditData(data);
    setIsEditMode(true);
    setOpen(true);
  };

  const handleFormSuccess = () => {
    handleClose();
    setRefreshTrigger(prev => prev + 1);
  }


  return (
    <DashboardLayout>
      <Box sx={{ flexGrow: 1 }}>
        <AppBar position="sticky"
          sx={{
            backgroundColor: "#D7DEED",
            borderRadius: '8px'
          }}>
          <Toolbar>
            <MaterialTypography
              variant="h5"
              noWrap
              fontWeight="bold"
              color='dark'
              sx={{ flexGrow: 1, display: { xs: 'none', sm: 'block' } }}
            >
              Test Plans
            </MaterialTypography>
            <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
              <MaterialSelect
                label='Project'
                value={selectedProject}
                options={projectList}
                size='small'
                sx={{ minWidth: '200px' }}
                onChange={(val) => setSelectedProject(val)}
              />
              <MaterialButton variant="contained" color='dark' size="small" onClick={handleTestPlanOpen}>Create Test Plan</MaterialButton>
            </Box>
          </Toolbar>
          <Box>
            <div style={{ width: "100%" }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "30px",
                  padding: "1px 20px",
                }}
              >
                <div
                  onClick={() => setActiveTab("active")}
                  style={{
                    position: "relative",
                    cursor: "pointer",
                    color: activeTab === "active" ? "#1a73e8" : "#666",
                    fontWeight: activeTab === "active" ? "600" : "normal",
                    paddingBottom: "6px",
                    fontSize: "14px",
                  }}
                >
                  Active Plans
                  {activeTab === "active" && (
                    <div
                      style={{
                        position: "absolute",
                        bottom: 0,
                        left: 0,
                        height: "2px",
                        width: "100%",
                        backgroundColor: "#1a73e8",
                      }}
                    ></div>
                  )}
                </div>

                <div
                  onClick={() => setActiveTab("closed")}
                  style={{
                    position: "relative",
                    cursor: "pointer",
                    color: activeTab === "closed" ? "#1a73e8" : "#666",
                    fontWeight: activeTab === "closed" ? "600" : "normal",
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    paddingBottom: "6px",
                    fontSize: "14px",
                  }}
                >
                  Completed Plans
                  {activeTab === "closed" && (
                    <div
                      style={{
                        position: "absolute",
                        bottom: 0,
                        left: 0,
                        height: "2px",
                        width: "100%",
                        backgroundColor: "#1a73e8",
                      }}
                    ></div>
                  )}
                </div>
              </div>
            </div>
          </Box>
        </AppBar>
      </Box>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12 }}>
          <div>
            {activeTab === "active" ? (
              <ActivePlans
                search={search}
                filter={filter}
                selectedProject={selectedProject}
                onEdit={handleEdit}
                refreshTrigger={refreshTrigger}
              />
            ) : (
              <ClosedPlans
                selectedProject={selectedProject}
                onEdit={handleEdit}
                refreshTrigger={refreshTrigger}
              />
            )}
          </div>
        </Grid>
      </Grid>

      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
        <DialogTitle sx={{ fontSize: '14px', fontWeight: 'bold', padding: 1 }}>{isEditMode ? 'Edit Test Plan' : 'Create Test Plan'}</DialogTitle>
        <DialogContent dividers sx={{
          overflow: 'hidden',
          '&::-webkit-scrollbar': { display: 'none' },
        }}>
          <AddTestPlan ref={testPlanRef} onSuccess={handleFormSuccess} editData={editData} />
        </DialogContent>
        <DialogActions>
          <MaterialButton onClick={handleClose} color="secondary" variant="outlined" size="small">
            Cancel
          </MaterialButton>
          <MaterialButton onClick={() => testPlanRef.current?.handleSubmit()} color="dark" variant="contained" size="small">
            {isEditMode ? 'Update' : 'Submit'}
          </MaterialButton>
        </DialogActions>
      </Dialog>


      {/* <UnderDevelopmentPage /> */}
    </DashboardLayout>
  )
}

export default TestPlans
